import React from 'react';
import pt from 'prop-types';
import StorefrontThemeEditor from 'containers/StorefrontThemeEditor';
import EditorLayout from 'editor/src/components/CheckoutEditorLayout';

export class StorefrontEditor extends React.PureComponent {
  static propTypes = {
    location: pt.object,
  };

  static contextTypes = {
    client: pt.object.isRequired,
    setLastUrl: pt.func.isRequired,
  };

  componentDidMount() {
    const { setLastUrl } = this.context;
    setLastUrl('/storefronts');
  }

  render() {
    const { location } = this.props;

    if (location.query.section === 'checkout') {
      return <EditorLayout {...this.props} />;
    }

    return <StorefrontThemeEditor {...this.props} />;
  }
}

export default StorefrontEditor;
